module.exports = __webpack_public_path__ + "static/media/information-management-kn.6d8df79a.svg";